<div class="advanced-filters-container no-select">
  <div class="widget-div">

    <!-- Card: copy General filters into Stock Take filters on this store -->
    <app-shared-widget-container-component class="expanded wide">
      <div title class="widget-div-heading">
        <app-display-icon
          [icon]="icons.filterVariant"
          [colour]="iconColours.secondary">
        </app-display-icon>
        <div>Copy to Stock Take Filters</div>
        <app-display-icon
          [tooltip]="'Copy saved General Filters into Stock Take Filters on this store. Original General Filters are unchanged.'"
          [icon]="icons.infoSlabCircleOutline"
          [colour]="iconColours.secondary">
        </app-display-icon>
      </div>

      <div block>
        <div class="form">
          <div class="form-column full-width">
            <div class="form-control-div">
              <label>
                General Filters to copy on <strong>{{ selectedStore?.name || 'this store' }}</strong>
              </label>
              @if (hasGeneralFilters) {
                <app-shared-custom-select
                  [placeholder]="'Select General Filters'"
                  [allowMultiple]="true"
                  [allowSelectAll]="true"
                  [showSearchBar]="false"
                  [showActionButtons]="true"
                  [showChips]="false"
                  [autoSubmitOnSelect]="true"
                  [setOptions]="generalFilterOptions()"
                  (selectionChange)="onGeneralToStockTakeSelectionChange($event)">
                </app-shared-custom-select>
              } @else {
                <p class="advanced-filters-copy-empty">
                  No saved general filters yet for this store. Use Edit on the Advanced Filters card below to create one.
                </p>
              }
            </div>
            <p class="advanced-filters-copy-hint">
              Each copy becomes a new Stock Take Filter with the same conditions. Copying the same General Filter again
              does not create a duplicate Stock Take copy.
            </p>
          </div>
        </div>
      </div>

      <div actions class="widget-actions">
        <button
          type="button"
          class="action-button"
          [disabled]="!canCopyToStockTake"
          (click)="onCopyToStockTakeClick()">
          @if (isCopyingToStockTake()) {
            <span class="advanced-filters-copy-spinner" aria-hidden="true"></span>
            Copying…
          } @else {
            <app-display-icon
              [colour]="iconColours.secondary"
              [tooltip]="'Copy selected General Filters to Stock Take Filters on this store'"
              [icon]="icons.contentCopy">
            </app-display-icon>
            Copy to Stock Take
          }
        </button>
      </div>
    </app-shared-widget-container-component>

    <!-- Card: edit advanced filters (opens shared editor modal) -->
    <app-shared-widget-container-component class="expanded wide">
      <div title class="widget-div-heading">
        <app-display-icon
          [icon]="icons.filterVariant"
          [colour]="iconColours.secondary">
        </app-display-icon>
        <div>Advanced Filters</div>
        <app-display-icon
          [tooltip]="'Create, rename and delete saved advanced filter groups for this store.'"
          [icon]="icons.infoSlabCircleOutline"
          [colour]="iconColours.secondary">
        </app-display-icon>
      </div>

      <div block>
        <div class="advanced-filters-card-body">
          <div class="form-control-div advanced-filters-category-field">
            <label>Filter category</label>
            <app-shared-custom-select
              [placeholder]="'Select category'"
              [allowMultiple]="false"
              [allowSelectAll]="false"
              [maxSelections]="1"
              [showSearchBar]="false"
              [showActionButtons]="false"
              [showChips]="false"
              [showCheckbox]="false"
              [autoSubmitOnSelect]="true"
              [closeOnAutoSubmit]="true"
              [setOptions]="categoryOptions()"
              (selectionChange)="onCategoryChange($event)">
            </app-shared-custom-select>
          </div>
          <p>
            Manage saved {{ categoryLabel().toLowerCase() }} for
            <strong>{{ selectedStore?.name || 'this store' }}</strong>.
            {{ editCardDescription() }}
          </p>
        </div>
      </div>

      <div actions class="widget-actions">
        <button
          type="button"
          class="action-button"
          (click)="onEditFiltersClick()">
          <app-display-icon
            [colour]="iconColours.secondary"
            [tooltip]="'Open the advanced filters editor'"
            [icon]="icons.pencil">
          </app-display-icon>
          Edit
        </button>
      </div>
    </app-shared-widget-container-component>

  </div>
</div>
